<div class="card">
  <div class="card-header card-header-grey">
    <h4 class="card-title">
      Modifier mon mot de passe
    </h4>
  </div>
  <br />
  <div class="row">
    <div class="col-12">
      <form [formGroup]="controlForm" action="" style="width: 100%;">
        <div class="row">
          <div class="col-md-4 col-sm-12 center-block">
            <mat-form-field appearance="outline" [color]="param.color">
              <mat-label>Nouveau Mot de Passe *</mat-label>
              <mat-pass-toggle-visibility #toggle matSuffix></mat-pass-toggle-visibility>
              <input matInput #password
                     formControlName="pass"
                     [type]="toggle.type"
                     placeholder="Mot de Passe">
              <mat-hint aria-live="polite">
                {{password.value.length}} / {{passwordComponent.max}}
              </mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12 center-block" style="margin-bottom:1rem;">
            <mat-password-strength #passwordComponent
                                   class="green"
                                   (onStrengthChanged)="onStrengthChanged($event)"
                                   [password]="password.value">
            </mat-password-strength>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12 center-block">
            <mat-form-field appearance="outline" [color]="param.color">
              <mat-label>Confirmer Mot de Passe *</mat-label>
              <mat-pass-toggle-visibility #toggle2 matSuffix></mat-pass-toggle-visibility>
              <input matInput
                     formControlName="confPass"
                     [type]="toggle2.type"
                     placeholder="Confirmation">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12 center-block text-center">
            <mat-password-strength-info class="icon-rose"
                                        [lowerCaseCriteriaMsg]="lowerMsg"
                                        [upperCaseCriteriaMsg]="upperMsg"
                                        [digitsCriteriaMsg]="digitMsg"
                                        [specialCharsCriteriaMsg]="speCaracMsg"
                                        [minCharsCriteriaMsg]="lengthMinMsg"
                                        [passwordComponent]="passwordComponent">
            </mat-password-strength-info>
          </div>
        </div>
      </form>
    </div>
  </div>
  <br />
  <br />
  <div class="col-md-4 col-sm-12 center-block" style="text-align: center;">
    <p>
      <input type="button" [disabled]="controlForm.invalid || pass != confPass" (click)="onSubmit()" class="btn btn-next btn-fill btn-rose btn-wd" name="next" value="Enregistrer">
    </p>
  </div>
</div>
